import { MAINLAND, TEKONG, UBIN } from './sgOutline'

export const OUTLINES = [MAINLAND, UBIN, TEKONG]
export const MAP_WIDTH = 600

const PAD = 0.04
const allPoints = OUTLINES.flat()
const lngs = allPoints.map(([lng]) => lng)
const lats = allPoints.map(([, lat]) => lat)
const rawLngMin = Math.min(...lngs)
const rawLngMax = Math.max(...lngs)
const rawLatMin = Math.min(...lats)
const rawLatMax = Math.max(...lats)
const lngPad = (rawLngMax - rawLngMin) * PAD
const latPad = (rawLatMax - rawLatMin) * PAD
const lngMin = rawLngMin - lngPad
const lngMax = rawLngMax + lngPad
const latMin = rawLatMin - latPad
const latMax = rawLatMax + latPad

// Height follows the real aspect ratio of the data so the island isn't stretched
export const MAP_HEIGHT = Math.round((MAP_WIDTH * (latMax - latMin)) / (lngMax - lngMin))
export const FULL_VIEW_BOX = { x: 0, y: 0, w: MAP_WIDTH, h: MAP_HEIGHT }

export const project = (lat, lng) => ({
  x: ((lng - lngMin) / (lngMax - lngMin)) * MAP_WIDTH,
  y: ((latMax - lat) / (latMax - latMin)) * MAP_HEIGHT, // flip so north is up
})

export const toPolygonPoints = (polygon) =>
  polygon
    .map(([lng, lat]) => {
      const { x, y } = project(lat, lng)
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')

export const haversineKm = (lat1, lng1, lat2, lng2) => {
  const toRad = (deg) => (deg * Math.PI) / 180
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

// Padded viewBox around a set of map points, keeping the map's aspect ratio
export const zoomToPoints = (points, minSize) => {
  const xs = points.map(({ x }) => x)
  const ys = points.map(({ y }) => y)
  let minX = Math.min(...xs)
  let maxX = Math.max(...xs)
  let minY = Math.min(...ys)
  let maxY = Math.max(...ys)
  const padX = Math.max((maxX - minX) * 0.35, minSize * 0.18)
  const padY = Math.max((maxY - minY) * 0.35, minSize * 0.18)
  minX -= padX
  maxX += padX
  minY -= padY
  maxY += padY
  let w = Math.max(maxX - minX, minSize)
  let h = Math.max(maxY - minY, (minSize * MAP_HEIGHT) / MAP_WIDTH)
  const aspect = MAP_WIDTH / MAP_HEIGHT
  if (w / h > aspect) h = w / aspect
  else w = h * aspect
  const cx = (minX + maxX) / 2
  const cy = (minY + maxY) / 2
  return { x: cx - w / 2, y: cy - h / 2, w, h }
}
